import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function FormDialog(props) {
    const {
        cancelButtonText = 'Cancel',
        submitButtonText = 'Submit',
        dialogTitle =  'Title',
        dialogSubHeading =  'Subheading',
        handleSubmit,
        handleClose,
        isOpen,
        children,
    } = props;
   
    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {dialogSubHeading}
                </DialogContentText>
                {children}
            </DialogContent>
            <DialogActions>
                {handleClose && (
                    <Button onClick={handleClose}>{cancelButtonText}</Button>
                )}
                {handleSubmit && (
                    <Button variant='contained' onClick={handleSubmit}>{submitButtonText}</Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

FormDialog.propTypes = {
    cancelButtonText: PropTypes.string,
    submitButtonText: PropTypes.string,
    dialogTitle: PropTypes.string,
    dialogSubHeading: PropTypes.string,
    handleSubmit: PropTypes.func,
    handleClose: PropTypes.func,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.any,
};

export default FormDialog;
